export const gamesList = {
  dev: null,
  // testbench-ctf: '/test-bench/ctf/tpgames.json',
  ctf: 'https://ctf-game.pages.dev/tpgames.json',
  'word-game': 'https://word-game-552.pages.dev/tpgames.json',
  'tank-game': 'https://tank-game.pages.dev/tpgames.json',
  sabotage: 'https://sabotage.pages.dev/tpgames.json',
};

export type GamesList = typeof gamesList;
